import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchDirrectoryData } from "../../redux/slicer/aluminaiSlicer";
import parse, { domToReact } from "html-react-parser";
import Preloader from "../../assets/sab.jpeg";
import AlumniImg from "../../assets/Banners/Alumni.jpg";
import { FaArrowLeft } from "react-icons/fa";

function AlumniDirectory() {
  const dispatch = useDispatch();

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;  // Match with API's page_size.  Consider making this configurable
                             // or fetching it from the API/Redux if it can change dynamically.

  const {
    data: dirrectoryData,
    pagination,
    loading: dirrectoryLoading,
    error: dirrectoryError,
  } = useSelector((state) => state.aluminai.dirrectory);

  useEffect(() => {
    // Dispatch the async thunk with page and page_size
    dispatch(fetchDirrectoryData({ page: currentPage, page_size: itemsPerPage }));
  }, [dispatch, currentPage, itemsPerPage]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const generatePageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= pagination.total_pages; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  if (dirrectoryLoading) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <img
          src={Preloader}
          alt="Loading..."
          className="w-24 h-24 sm:w-32 sm:h-32"
        />
      </div>
    );
  }

  if (dirrectoryError) {
    return <div className="text-red-600">Error: {dirrectoryError}</div>;
  }

  return (
    <div className="bg-gray-100 min-h-screen">
      {/* Banner Section */}
      <div className="relative max-w-full mx-auto">
        <div className="contain overflow-hidden w-full  h-[400px]">
          <img
            src={AlumniImg}
            alt="Program Details Banner"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute top-1/3 left-1/2 transform -translate-x-1/2 text-center text-white">
            <h2 className="text-4xl md:text-5xl  font-bold  font-titillium ">
              Alumni Directory
            </h2>
            <p className="text-lg mt-10 bg-img-description  font-titillium"></p>
          </div>
        </div>
      </div>

      {/* Program Details Section */}
      <div className="container mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow overflow-hidden rounded-md">
          <div className="p-6">
            {/* Program Description */}
            <div id="directory">
              <h2 className="text-3xl sm:text-4xl text-primary-color font-titillium text-center md:text-left">
                Alumni Directory
              </h2>
            </div>

            {dirrectoryLoading ? (
              <div className="flex items-center justify-center">
                <p>Loading directory data...</p>
              </div>
            ) : dirrectoryError ? (
              <div className="flex items-center justify-center">
                <p className="text-red-500">
                  Error loading directory: {dirrectoryError}
                </p>
              </div>
            ) : (
              <div className="overflow-x-auto py-6">
            
                <table className="min-w-full bg-white border border-gray-300 shadow-md rounded-lg">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="py-3 px-6 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                        Name
                      </th>
                      <th className="py-3 px-6 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                        Designation
                      </th>
                      <th className="py-3 px-6 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                        SAB Qualifications
                      </th>
                      <th className="py-3 px-6 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                        Intake
                      </th>
                      <th className="py-3 px-6 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                        Company Name
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {dirrectoryData.map((item, index) => (
                      <tr
                        key={index}
                        className={index % 2 === 0 ? "bg-gray-50" : ""}
                      >
                        <td className="py-4 px-6 whitespace-nowrap text-sm font-medium text-gray-900 text-left">
                          {item?.name || "N/A"}
                        </td>
                        <td className="py-4 px-6 whitespace-nowrap text-sm text-gray-500 text-left">
                          {item?.designation || "N/A"}
                        </td>
                        <td className="py-4 px-6 whitespace-normal text-sm text-gray-500 text-left">
                          {item?.sab_academic_qualifications || "N/A"}
                        </td>
                        <td className="py-4 px-6 whitespace-nowrap text-sm text-gray-500 text-left">
                          {item?.intake || "N/A"}
                        </td>
                        <td className="py-4 px-6 whitespace-normal text-sm text-gray-500 text-left">
                          {item?.official_address || "N/A"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {/* Pagination */}
                <div className="flex justify-center mt-4">
                  {generatePageNumbers().map((pageNumber) => (
                    <button
                      key={pageNumber}
                      onClick={() => handlePageChange(pageNumber)}
                      className={`mx-1 px-3 py-1 rounded ${
                        currentPage === pageNumber
                          ? "bg-primary-color text-white"
                          : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                      }`}
                    >
                      {pageNumber}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AlumniDirectory;